import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  className = ''
}: SectionHeadingProps) {
  return <div className={`mx-auto max-w-2xl text-center ${className}`} data-id="element-149" data-mp="3f36pffvoxj5k">
      {eyebrow && <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-brand-terra sm:text-[11px]" data-id="element-150" data-mp="3k0f9xn4b9z9z">
          {eyebrow}
        </p>}
      <h2 className="mt-4 text-[1.75rem] font-semibold leading-[1.15] tracking-tight text-brand-navy sm:text-4xl" data-id="element-151" data-mp="gjzrtka4konw">
        {title}
      </h2>
      {subtitle && <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-brand-gray sm:text-base" data-id="element-152" data-mp="1shfpxkdze9t">
          {subtitle}
        </p>}
    </div>;
}